/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadPartiesDetails(partiesList) {
  return await api
    .post(`/org/getparty`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadStateDetails(stateList) {
  return await api
    .post(`/masters/getstate`, stateList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartiesDetails(partiesList) {
  return await api
    .post(`/org/createparty`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPartiesCategoryDetails(partiesList) {
  return await api
    .post(`/org/getpartycategory`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartiesCategoryDetails(partiesList) {
  return await api
    .post(`/org/createpartycategory`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function updatePartiesDetails(partiesList) {
  return await api
    .put(`/org/updateparty`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deletePartiesDetails(partiesList) {
  return await api
    .post(`/org/deleteparty`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesCollectDetails(partiesList) {
  return await api
    .post(`/org/getpartytocollect`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPartiesPayDetails(partiesList) {
  return await api
    .post(`/org/getpartytopay`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPartiesTransactionDetails(partiesList) {
  return await api
    .post(`/org/getpartytransaction`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPartiesLedgerStatementDetails(partiesList) {
  return await api
    .post(`/org/getledgerstatement`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
const remotes = {
  loadPartiesDetails,
  loadPartiesCollectDetails,
  loadPartiesPayDetails,
  loadPartiesTransactionDetails,
  createPartiesDetails,
  loadRecordsMetaData,
  loadStateDetails,
  updatePartiesDetails,
  deletePartiesDetails,
  loadPartiesCategoryDetails,
  loadPartiesLedgerStatementDetails,
  createPartiesCategoryDetails,
};

export default remotes;
